'use client';

import { useSpotMarketsSortedByMarketIndex } from '../spotMarkets/useSpotMarketsSortedByMarketIndex';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

const useSwapMarkets = () => {
	const { fromMarketIndex, toMarketIndex } = useDriftStore((s) => s.swap);
	const spotMarketsSortedByMarketIndex = useSpotMarketsSortedByMarketIndex();
	const swapFromMarket = spotMarketsSortedByMarketIndex[fromMarketIndex];
	const swapToMarket = spotMarketsSortedByMarketIndex[toMarketIndex];

	return { swapFromMarket, swapToMarket };
};

export default useSwapMarkets;
